import styled from "styled-components"

export const StyledSidebar = styled.div`
  margin-top: 3rem;
`
